import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteEmpleo,
  getEmpleoById,
  postEmpleo,
  updateEmpleo,
} from "../../../../api/empleo";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { formatDateOnlyForInput } from "../../../../utils/helpers";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Autocomplete } from "@material-ui/lab";
import { getLocalidades } from "../../../../api/localidad";
import MultiTabBlock from "../../../components/MultiTabBlock";
import { getUsers } from "../../../../api/user";
import { getInteresados } from "../../../../api/interesado";
import Table, { dateFormatter } from "../../../components/tables/table";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import Editor from "../../../components/editor/Editor";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { shallowEqual, useSelector } from "react-redux";
import { FlashOn } from "@material-ui/icons";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyEmpleo() {
  return {
    titulo: "",
    fecha_publicacion: null,
    interesados: [],
    active: true,
  };
}

export default function EditEmpleoPage() {
  const [empleo, setEmpleo] = useState(getEmptyEmpleo());
  const [localidades, setLocalidades] = useState([]);
  // const [users, setUsers] = useState([]);
  // const [interesados, setInteresados] = useState([]);
  const [selectedAcceso, setSelectedAcceso] = useState("Únicamente socios");
  const [selectedLocalidad, setSelectedLocalidad] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const empleoId = useParams().id;
  const history = useHistory();
  const languages = useSelector(
    (store) => store.authentication?.languages,
    shallowEqual,
  );

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetch = async () => {
      // const resInteresados = await getInteresados();
      // if (resInteresados.status === 200) {
      //   setInteresados(resInteresados.data);
      // }
      // const resUsers = await getUsers();
      // if (resUsers.status === 200) {
      //   setUsers(resUsers.data);
      // }
      const resLocalidades = await getLocalidades();
      if (resLocalidades.status === 200) {
        setLocalidades(resLocalidades.data);
      }
      if (!empleoId) {
        disableLoadingData();
        return;
      }
      getEmpleoById(empleoId)
        .then((res) => {
          if (res.status === 200) {
            const empleo = res.data;
            setSelectedAcceso(res.data.acceso || "Únicamente socios");
            setEmpleo(empleo);
            if (res.data.lugar) {
              const lugarId = res.data.lugar?._id || res.data.lugar;
              setSelectedLocalidad(
                resLocalidades.data.find(
                  (x) => String(x._id) === String(lugarId),
                ) || null,
              );
            }
            disableLoadingData();
          }
        })
        .catch((error) => {
          alertError({ error: error, customMessage: "Could not get empleo." });
          history.push("/empleos");
        });
    };
    fetch();
  }, [empleoId, disableLoadingData, history]);

  function saveEmpleo() {
    let saveEmpleo = empleo;
    saveEmpleo.acceso = selectedAcceso || "Únicamente socios";
    saveEmpleo.lugar = selectedLocalidad?._id;
    if (!empleoId) {
      postEmpleo(saveEmpleo)
        .then((res) => {
          if (res.status === 201) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Empleo successfully created.",
            });
            history.push("/empleos");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save empleo.",
          });
        });
    } else {
      updateEmpleo(empleoId, saveEmpleo)
        .then((res) => {
          if (res.status === 200) {
            alertSuccess({
              title: "Saved!",
              customMessage: "Changes successfully saved.",
            });
            history.push("/empleos");
          }
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "Could not save changes.",
          });
        });
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;

      if (!empleo[element]) empleo[element] = {};
      let newText = empleo[element];
      newText[lang] = event.target.value;
      setEmpleo({ ...empleo, [element]: newText });
    } else setEmpleo({ ...empleo, [element]: event.target.value });
  };

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === " ") return;
      if (!empleo[element]) empleo[element] = {};
      let newEmpleo = empleo[element];
      newEmpleo[lang] = value;
      setEmpleo({ ...empleo, [element]: newEmpleo });
    } else setEmpleo({ ...empleo, [element]: value });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <div className="d-flex align-text-center">
          <div className="col-md-6">
            <TextField
              id={`titulo`}
              label="Titulo"
              value={
                empleo.titulo && empleo.titulo[lang] ? empleo.titulo[lang] : ""
              }
              onChange={handleChange("titulo", lang)}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
          </div>
          <div className="col-md-6">
            <TextField
              id={`url`}
              label="URL"
              value={empleo.url}
              onChange={handleChange("url")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-12">
            <label>Descripción</label>
            <Editor
              body={(empleo.descripcion && empleo.descripcion[lang]) || ""}
              setBody={(new_body) =>
                handleChangeEditor("descripcion", lang, new_body)
              }
              className="max-height"
              lang={lang}
              placeholder={"Enter text descripcion here..."}
            />
          </div>
        </div>
        <div className="d-flex align-text-center mt-2">
          <div className="col-md-12">
            <label>Requisitos</label>
            <Editor
              body={(empleo.requisitos && empleo.requisitos[lang]) || ""}
              setBody={(new_body) =>
                handleChangeEditor("requisitos", lang, new_body)
              }
              className="max-height"
              lang={lang}
              placeholder={"Enter text requisitos here..."}
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-4">
            <TextField
              id={`empresa`}
              label="Empresa"
              value={empleo.empresa}
              onChange={handleChange("empresa")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`horario`}
              label="Horario"
              value={empleo.horario}
              onChange={handleChange("horario")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`salario`}
              label="Salario"
              value={empleo.salario}
              onChange={handleChange("salario")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-4">
            <TextField
              id={`contacto`}
              label="Contacto"
              value={empleo.contacto}
              onChange={handleChange("contacto")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`email`}
              label="Email"
              value={empleo.email}
              onChange={handleChange("email")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
          <div className="col-md-4">
            <TextField
              id={`tel`}
              label="Teléfono"
              value={empleo.tel}
              onChange={handleChange("tel")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
        </div>
        <div className="d-flex align-text-center">
          <div className="col-md-6">
            <TextField
              id={`ref`}
              label="Referencia"
              value={empleo.ref}
              onChange={handleChange("ref")}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
            />
          </div>
          <div className="col-md-6">
            <TextField
              id="fecha_publicacion"
              label="Fecha de publicación"
              type="date"
              value={formatDateOnlyForInput(empleo.fecha_publicacion)}
              onChange={(e) => {
                const val = e.target.value;
                setEmpleo({
                  ...empleo,
                  fecha_publicacion: val ? new Date(val).toISOString() : null,
                });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
          </div>
        </div>
      </>
    );
  };
  const renderMultilanguageTabContentEnlace = (lang) => {
    return (
      <>
        <TextField
          id={`enlace`}
          label="Url amigable"
          value={
            empleo.enlace && empleo.enlace[lang] ? empleo.enlace[lang] : ""
          }
          onChange={handleChange("enlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          id={`tituloEnlace`}
          label="Titulo SEO"
          value={
            empleo.tituloEnlace && empleo.tituloEnlace[lang]
              ? empleo.tituloEnlace[lang]
              : ""
          }
          onChange={handleChange("tituloEnlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          id={`descripcionEnlace`}
          label="Descripción SEO"
          value={
            empleo.descripcionEnlace && empleo.descripcionEnlace[lang]
              ? empleo.descripcionEnlace[lang]
              : ""
          }
          onChange={handleChange("descripcionEnlace", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
      </>
    );
  };

  const renderContentDatosGenerales = () => {
    return (
      <>
        <div className="d-flex align-text-center">
          <div className="col-md-6">
            <Autocomplete
              className="w-100 mr-5"
              id="autocomplete-acceso"
              options={["Únicamente socios", "Público"]}
              value={selectedAcceso || "Únicamente socios"}
              onChange={(event, selected) => {
                setSelectedAcceso(selected || "Únicamente socios");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Seleccionar Tipo de Acceso"
                />
              )}
            />
          </div>
          <div className="col-md-6">
            <Autocomplete
              className="w-100 mr-5"
              id="autocomplete-lugar"
              options={localidades}
              getOptionLabel={(option) => option?.fullName || ""}
              getOptionSelected={(option, value) => option._id === value?._id}
              value={selectedLocalidad || null}
              onChange={(event, selected) => {
                setSelectedLocalidad(selected);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Seleccionar lugar"
                />
              )}
            />
          </div>
        </div>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContent}
        />
      </>
    );
  };
  // Función para limpiar HTML y convertir entidades HTML a texto
  const stripHTML = (html) => {
    if (!html) return "";

    // Crear un elemento temporal para extraer el texto
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;

    // Obtener el texto sin HTML
    let text = tmp.textContent || tmp.innerText || "";

    // Limpiar espacios múltiples y saltos de línea
    text = text.replace(/\s+/g, " ").trim();

    return text;
  };

  // Función para generar URL amigable desde un texto
  const generateSlug = (text) => {
    if (!text) return "";

    // Limpiar HTML primero
    let slug = stripHTML(text);

    // Convertir a minúsculas
    slug = slug.toLowerCase();

    // Reemplazar caracteres especiales y acentos
    slug = slug
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Eliminar diacríticos
      .replace(/[^a-z0-9\s-]/g, "") // Eliminar caracteres especiales
      .replace(/\s+/g, "-") // Reemplazar espacios con guiones
      .replace(/-+/g, "-") // Reemplazar múltiples guiones con uno solo
      .replace(/^-|-$/g, ""); // Eliminar guiones al inicio y final

    return slug;
  };

  const renderContentEnlace = () => {
    const handleGenerateSEO = async () => {
      if (!languages || languages.length === 0) {
        alertError({
          customMessage: "No hay idiomas disponibles para generar el SEO",
        });
        return;
      }

      // Obtener información del empleo para generar el SEO
      const empleoInfo = {
        titulo: empleo && empleo.titulo ? empleo.titulo : {},
        descripcion: empleo && empleo.descripcion ? empleo.descripcion : {},
      };

      try {
        // Mostrar mensaje de carga
        alertSuccess({
          title: "Generando SEO...",
          customMessage:
            "Por favor espera mientras se genera el SEO para todos los idiomas",
        });

        // Generar SEO para cada idioma
        const seoData = {};

        for (const lang of languages) {
          const langCode = lang.isocode;
          if (!langCode) continue;

          // Preparar contexto del empleo en el idioma actual con validaciones
          const titulo =
            empleoInfo.titulo && empleoInfo.titulo[langCode]
              ? empleoInfo.titulo[langCode]
              : empleoInfo.titulo && empleoInfo.titulo["es"]
              ? empleoInfo.titulo["es"]
              : "";
          const descripcion =
            empleoInfo.descripcion && empleoInfo.descripcion[langCode]
              ? empleoInfo.descripcion[langCode]
              : empleoInfo.descripcion && empleoInfo.descripcion["es"]
              ? empleoInfo.descripcion["es"]
              : "";

          // Limpiar HTML de los textos
          const tituloLimpio = stripHTML(titulo);
          const descripcionLimpia = stripHTML(descripcion);

          // Generar título SEO (máximo 60 caracteres)
          const tituloSEO =
            tituloLimpio && tituloLimpio.length > 0
              ? tituloLimpio.length > 60
                ? tituloLimpio.substring(0, 57) + "..."
                : tituloLimpio
              : `Empleo ${empleoId || ""}`;

          // Generar descripción SEO (máximo 160 caracteres)
          let descripcionSEO = "";
          if (descripcionLimpia && descripcionLimpia.length > 0) {
            descripcionSEO =
              descripcionLimpia.length > 160
                ? descripcionLimpia.substring(0, 157) + "..."
                : descripcionLimpia;
          }

          if (!descripcionSEO || descripcionSEO.length === 0) {
            descripcionSEO = `Información sobre el empleo ${tituloSEO}`;
          }

          // Generar URL amigable
          const urlAmigable = generateSlug(tituloLimpio || tituloSEO);

          seoData[langCode] = {
            enlace: urlAmigable,
            tituloEnlace: tituloSEO,
            descripcionEnlace: descripcionSEO,
          };
        }

        // Actualizar el empleo con el SEO generado
        setEmpleo((prevEmpleo) => ({
          ...prevEmpleo,
          enlace: {
            ...prevEmpleo.enlace,
            ...Object.fromEntries(
              Object.entries(seoData).map(([lang, data]) => [
                lang,
                data.enlace,
              ]),
            ),
          },
          tituloEnlace: {
            ...prevEmpleo.tituloEnlace,
            ...Object.fromEntries(
              Object.entries(seoData).map(([lang, data]) => [
                lang,
                data.tituloEnlace,
              ]),
            ),
          },
          descripcionEnlace: {
            ...prevEmpleo.descripcionEnlace,
            ...Object.fromEntries(
              Object.entries(seoData).map(([lang, data]) => [
                lang,
                data.descripcionEnlace,
              ]),
            ),
          },
        }));

        alertSuccess({
          title: "SEO generado!",
          customMessage: `Se ha generado el SEO para ${
            Object.keys(seoData).length
          } idiomas`,
        });
      } catch (error) {
        console.error("Error generando SEO:", error);
        alertError({
          error: error,
          customMessage: "No se ha podido generar el SEO",
        });
      }
    };

    return (
      <>
        <div className="d-flex justify-content-end mb-3">
          <Button
            variant="contained"
            onClick={handleGenerateSEO}
            startIcon={<FlashOn />}
            style={{
              backgroundColor: "#9c27b0",
              color: "#fff",
            }}
          >
            GENERAR
          </Button>
        </div>
        <MultilanguageTabBlock
          multilanguageTabContent={renderMultilanguageTabContentEnlace}
        />
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/empleos"),
            onSave: saveEmpleo,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!empleoId,
            setObj: setEmpleo,
            obj: empleo,
          })}
          <CardHeader title="Editar empleo"></CardHeader>
          <CardBody>
            <MultiTabBlock
              tabs={[
                {
                  enable: true,
                  title: "Datos Generales",
                  renderContent: renderContentDatosGenerales,
                },
                {
                  enable: empleoId !== undefined,
                  title: "SEO",
                  renderContent: renderContentEnlace,
                },
              ]}
            />

            {/* Checkboxes */}
            <div style={{ marginTop: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={empleo.active || false}
                    onChange={() =>
                      setEmpleo({ ...empleo, active: !empleo.active })
                    }
                    name="checkActive"
                  />
                }
                label="Active"
              />
            </div>
          </CardBody>
        </Card>
        {empleoId && (
          <>
            <ConfirmDialog
              title={"Are you sure you want to delete this empleo?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                deleteEmpleo(empleoId)
                  .then((res) => {
                    if (res.status === 204 || res.status === 200) {
                      alertSuccess({
                        title: "Deleted!",
                        customMessage: "Empleo deleted successfully",
                      });
                      history.push("/empleos");
                    }
                  })
                  .catch((error) => {
                    alertError({
                      error: error,
                      customMessage: "Could not delete empleo.",
                    });
                  });
              }}
            />
          </>
        )}
      </>
    );
}
